import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import { gql } from '@apollo/client';
import { useBasketData, useDeliveryBasketData } from 'app/hooks/accessors';
import { useBasketDataByLocation } from 'app/components/OpenBasketButton/hooks';
import BasketButton from '../BasketButton';


const locales = {
    ru: {
        titleDefault: 'Ваш заказ:',
        titleDelivery: 'Общая стоимость:',
        titleLoading: 'Загрузка...',
    },
    en: {
        titleDefault: 'Your order:',
        titleDelivery: 'Your order:',
        titleLoading: 'Loading...',
    },
};


const isHideBasket = (location) => (
    location.pathname.includes('/profile')
    || location.pathname.includes('/thx')
    || location.pathname.includes('/auth')
);

const isDelivery = (location) => location.pathname.includes('/delivery');

const CART_DATA_FOR_DESKTOP_BUTTON_QUERY = gql`
    query CART_DATA_FOR_DESKTOP_BUTTON(
        $period: String!
    ) {
        cart(
            period: $period
        ) {
            type
            period
            isSubscriptionActivated,
            sections {
                cartType
                id
                items {
                    dish_id
                }
            }
            totals {
                total_discount_price
                static_common_price
                static_discount_price
                total_price
                delivery_price
            }
            discount_conditions {
                differenceBetweenPromocodeAndOrder
                discountValue
                discountType
                promocode
                isPromoCodeExists
            }
        }
    }
`;


const DELIVERY_CART_DATA_FOR_DESKTOP_BUTTON_QUERY = gql`
    query  DELIVERY_CART_DATA_FOR_DESKTOP_BUTTON(
        $deliveryId: ID!
    ) {
        cart: deliveryCart(
            delivery_id: $deliveryId,
        ) {
            type
            period
            isSubscriptionActivated,
            sections {
                id
                cartType
                items {
                    dish_id
                }
            }
            totals {
                total_discount_price
                static_common_price
                static_discount_price
            }
            discount_conditions {
                differenceBetweenPromocodeAndOrder
                discountValue
                discountType
                promocode
                isPromoCodeExists
            }
        }
    }
`;

const useCartByLocation = () => {
    const isDeliveryBasket = window.location.pathname.includes('app/delivery');
    const newBasket = useBasketData(
        CART_DATA_FOR_DESKTOP_BUTTON_QUERY,
        'BasketButtonWrapper',
        'cache-and-network',
    );
    const deliveryBasket = useDeliveryBasketData(
        DELIVERY_CART_DATA_FOR_DESKTOP_BUTTON_QUERY,
        'BasketButtonWrapper',
        'cache-and-network',
    );

    return isDeliveryBasket ? deliveryBasket : newBasket;
};

const BasketButtonWrapper = (props) => {
    const {
        localeContext: { locale },
        location,
        onClickBasketButton,
        className = '',
    } = props;

    const { cart } = useCartByLocation();

    if (cart) {
        const {
            isSubscriptionActivated,
            sections,
            totals: {
                total_discount_price: totalPrice,
                static_common_price: commonPrice,
                static_discount_price: discountPrice,
            },
        } = cart;
        let price;
        if ('total_discount_price' in cart.totals) { // корзина офомления нового заказа
            price = totalPrice;
        } else { // корзина доставки
            price = isSubscriptionActivated ? discountPrice : commonPrice;
        }
        const count = sections.reduce((acc, section) => acc + section.items.length, 0);

        const title = isDelivery(location)
            ? locales[locale].titleDelivery
            : locales[locale].titleDefault;

        const icon = isDelivery(location) ? 'arrow' : 'basket';
        return (
            <BasketButton
                locale={locale}
                className={className}
                count={count}
                price={price}
                title={title}
                icon={icon}
                isDelivery={isDelivery(location)}
                hidden={isHideBasket(location)}
                onClick={onClickBasketButton}
            />
        );
    }


    return <BasketButton title={locales[locale].titleLoading} hidden={isHideBasket(location)} />;
};

BasketButtonWrapper.propTypes = {
    localeContext: PropTypes.shape({
        locale: PropTypes.string.isRequired,
    }).isRequired,
    location: PropTypes.shape({}).isRequired,
    className: PropTypes.string,
    onClickBasketButton: PropTypes.func.isRequired,
};

export default BasketButtonWrapper;
